import React from "react";
import { coachDemoImg } from "../../constant/imagePath";
import { AiFillHeart, AiFillStar } from "react-icons/ai";
import classes from "./FavouriteDetailCardsMobile.module.css";
import { FaMapMarkerAlt } from "react-icons/fa";
import { BsDot } from "react-icons/bs";
import Colors from "../assets/Colors";
import Fonts from "../assets/Fonts";
import { Button } from "../Button/Button";
import { Col, Row } from "react-bootstrap";
import StarRatings from "react-star-ratings";

const FavouriteDetailCards = ({ data, onClick, isShowFilter }) => {
  return (
    <>
      <div className={classes.styledFavouriteDetailCardsDiv} onClick={onClick}>
        <img className={classes.favouriteDetailCardsImg} src={coachDemoImg} />
        <div className={classes.cardDetail}>
          <div>
            <p
              style={{
                ...Fonts.h7,
                fontSize: "14px",
                lineHeight: "20px",
                color: Colors.neutralShadesOfNero,
              }}
            >
              {data?.firstName}
            </p>

            <p
              style={{
                ...Fonts.h7,
                fontSize: "14px",
                lineHeight: "20px",
                color: Colors.neutralShadesOfNero,
              }}
            >
              {data?.lastName}
            </p>

            <div
              className={`${classes.dFlexAlignItemCenter} ${classes.ratingAndPerHour}`}
            >
              <p className={`${classes.aCenter} ${classes.starRatingDiv}`}>
                <StarRatings
                  numberOfStars={1}
                  starRatedColor={Colors.mainShadeOfRed}
                  starEmptyColor={Colors.neutralShadesOfGainsboro}
                  rating={data?.rating / 5}
                  starDimension="16px"
                  css={classes.star}
                />
                <span style={{ ...Fonts.b4 }} className={classes.ml4}>
                  {data?.rating?.toFixed(1)}
                </span>
              </p>
              <span
                className={classes.dot}
                style={{ background: Colors.neutralShadesOfDimGray }}
              />
              <p
                className={classes.aCenter}
                style={{ color: Colors.neutralShadesOfNero, ...Fonts.b4 }}
              >
                <span
                  style={{
                    ...Fonts.h7,
                    fontSize: "14px",
                    lineHeight: "24px",
                  }}
                >
                  ${data?.price}
                </span>
                /hr
              </p>
            </div>
            <div className={`${classes.aCenter} ${classes.mt12}`}>
              {/* <FaMapMarkerAlt
                className={` ${classes.marginRight10}`}
                style={{ color: Colors.neutralShadesOfNero }}
                size={12}
              /> */}
              <p
                style={{
                  ...Fonts.otherMedium,
                  fontFamily: "inter-400",
                  color: Colors.neutralShadesOfDimGray,
                }}
              >
                {data?.distance}
              </p>
              <span
                className={`${classes.dot} `}
                style={{ background: Colors.neutralShadesOfDimGray }}
              />
              <p
                style={{
                  ...Fonts.otherMedium,
                  fontFamily: "inter-400",
                  color: Colors.neutralShadesOfDimGray,
                }}
              >
                {data?.speciality}
              </p>
            </div>
          </div>
          {/* Favorite Icon */}
          <div className={classes.dFlexJustifyContentEnd}>
            {isShowFilter && <AiFillHeart className={classes.iconHeartColor} />}
          </div>
        </div>
      </div>
    </>
  );
};

export default FavouriteDetailCards;
